/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('TemplateEventTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		TemplateEventFactory,
		FindAllTemplateEventsByQueryParamsNonPageableFactory,
		NoPagingTemplateEventFactory,
		NoPagingEventTypeFactory,
		NoPagingArticleFactory,
		TemplateEventFindArticleFilteredByDefaultDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSecondDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSpectatorFactory,
		TemplateEventFindArticleFilteredByDefaultInsuranceFactory,
		TemplateEventFindArticleFilteredByDefaultHotelFactory,
		TemplateEventFindArticleFilteredByDefaultFuelFactory,
		TemplateEventFindArticleFilteredByDefaultInstructionFactory
	) {
		$scope.templateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newTemplateEvent', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(templateEvent) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editTemplateEvent', {
				templateEventId: templateEvent.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getTemplateEventList = function() {
			FindAllTemplateEventsByQueryParamsNonPageableFactory.query(
				{
					eventTypeId: angular.isDefined($scope.eventTypeId) ? $scope.eventTypeId : null,
					defaultDriverId: angular.isDefined($scope.defaultDriverId) ? $scope.defaultDriverId : null,
					defaultSecondDriverId: angular.isDefined($scope.defaultSecondDriverId) ? $scope.defaultSecondDriverId : null,
					defaultSpectatorId: angular.isDefined($scope.defaultSpectatorId) ? $scope.defaultSpectatorId : null,
					defaultInsuranceId: angular.isDefined($scope.defaultInsuranceId) ? $scope.defaultInsuranceId : null,
					defaultHotelId: angular.isDefined($scope.defaultHotelId) ? $scope.defaultHotelId : null,
					defaultFuelId: angular.isDefined($scope.defaultFuelId) ? $scope.defaultFuelId : null,
					defaultInstructionId: angular.isDefined($scope.defaultInstructionId) ? $scope.defaultInstructionId : null,

					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.templateEventList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedTemplateEventId = id;
			$('#deleteTemplateEventConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			TemplateEventFactory.delete(
				{ id: $scope.selectedTemplateEventId },
				function() {
					$scope.loadAll();
					$('#deleteTemplateEventConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteTemplateEventConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
